import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import MedicalPracticesPage from "./pages/MedicalPracticesPage";
import TreeServicePage from "./pages/TreeServicePage";
import ExclusiveTreePage from "./pages/ExclusiveTreePage";
import BookingPage from "./pages/BookingPage";
import ThankYouPage from "./pages/ThankYouPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/medical-practices" element={<MedicalPracticesPage />} />
          <Route path="/tree-service" element={<TreeServicePage />} />
          <Route path="/tree-service-exclusive" element={<ExclusiveTreePage />} />
          <Route path="/book" element={<BookingPage />} />
          <Route path="/thank-you" element={<ThankYouPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
